import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddProductMutation, useDeleteProductMutation, useEditProductMutation } from "../../../redux/api/products/productsApi";
import { EntProduct } from "../../../models/product";
import { getCookie } from "typescript-cookie";



const useProducts = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addProduct] = useAddProductMutation();
    const [deleteProduct] = useDeleteProductMutation();
    const [editProduct] = useEditProductMutation();

    async function onAddProduct(newProduct: EntProduct): Promise<boolean> {
        try {
            let status: boolean = false;
            await addProduct(newProduct).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }


    async function onDeleteProduct(product: EntProduct) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteProduct(product.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditProduct(editedProduct: EntProduct): Promise<boolean> {
        try {
            let status: boolean = false;
            await editProduct(editedProduct).then((response: any) => {
                if (response.error) {
                                            const isKyrgyz = getCookie('i18next') === 'ky';
                                            const lang = isKyrgyz ? 'kg' : 'ru';
                                            const res = response.error.data?.res;
                                            const errorMessages = Array.isArray(res)
                                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                : response.error.data?.msg || t('unknownError'); 
                                            throw new Error(errorMessages);
                                        }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddProduct, onDeleteProduct, onEditProduct }

}
export { useProducts };

